import type { DiscountAwarePrices } from "@b2bportal/lodging-api";

/**
 * Percentage off a strikethrough (discount-aware) price, rounded; 0 when there
 * is no discount. Shared by the hotel card/shop discount pills and checkout
 * offer tracking.
 *
 * Accepts a missing price — the field is optional on both lodgings and room
 * rates — so callers don't need to guard.
 */
export const getPercentOff = (
  discountAware: DiscountAwarePrices | undefined | null
): number => {
  const original = discountAware?.priceWithNoDiscounts?.fiat?.value;
  const discounted =
    discountAware?.priceWithAllDiscounts?.fiat?.value ??
    discountAware?.priceWithUnmanagedDiscounts?.fiat?.value;

  if (
    original == null ||
    discounted == null ||
    original <= 0 ||
    discounted >= original
  ) {
    return 0;
  }

  return Math.round(100 - (discounted / original) * 100);
};
